import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./hora.css";

function HoraMuhurta() {
  const getCurrentDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const [params, setParams] = useState({
    date: getCurrentDate(),
    time: getCurrentTime(),
    latitude: "24",
    longitude: "76",
    tz: "5.5",
  });

  const [language, setLanguage] = useState("en");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchHoraMuhurta = () => {
    setLoading(true);
    setError("");
    setResult(null);

    fetch(
      `https://api.jyotishamastroapi.com/api/panchang/hora-muhurta?date=${params.date}&time=${params.time}&latitude=${params.latitude}&longitude=${params.longitude}&tz=${params.tz}&lang=${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API Error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data && data.response) {
          setResult(data.response);
        } else {
          setError("No data found.");
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchHoraMuhurta();
  }, [language]);

  return (
    <div className="container">
        <div className="ra-main-hora">

          <div
  className="DailyPanchang-top-buttons"
   style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
>
   {/* Top Buttons */}
          <div
            className="DailyPanchang-top-buttons"
            style={{
              marginBottom: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Calendar Logo SVG */}
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                style={{ marginRight: "0.75rem" }}
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="16"
                  rx="2"
                  stroke="#333"
                  strokeWidth="2"
                  fill="#f5f5f5"
                />
                <path
                  d="M16 3v4M8 3v4"
                  stroke="#333"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path d="M3 9h18" stroke="#333" strokeWidth="2" />
              </svg>
  
    <Link to="/panchang" style={{ textDecoration: "none",marginRight: "10px"  }}>
                            <button type="button">📅 Daily Panchang</button>
                          </Link>
              <Link to="/MonthlyPanchang" style={{ textDecoration: "none", marginRight: "10px" }}>
                <button type="button">📅 Monthly Panchang</button>
              </Link>
               
              <Link to="/Choghadiya" style={{ textDecoration: "none",marginRight: "10px"  }}>
                <button type="button">Choghadiya</button>
              </Link>
             
            </div>
          </div>
</div>
      <h2 className="hora-title">☀️ Hora Muhurta</h2>

      <div className="hora-inputs">
        <input
          type="text"
          value={params.date}
          onChange={(e) => setParams({ ...params, date: e.target.value })}
          placeholder="Date (DD/MM/YYYY)"
        />
        <input
          type="text"
          value={params.time}
          onChange={(e) => setParams({ ...params, time: e.target.value })}
          placeholder="Time (HH:MM)"
        />

        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="hora-select"
        >
          <option value="en">English</option>
          <option value="hi">Hindi</option>
          <option value="be">Bengali</option>
          <option value="ta">Tamil</option>
          <option value="te">Telugu</option>
          <option value="ka">Kannada</option>
          <option value="ml">Malayalam</option>
          <option value="mr">Marathi</option>
          <option value="gr">Gujarati</option>
        </select>

        <button onClick={fetchHoraMuhurta} disabled={loading}>
          {loading ? "Loading..." : "Get Hora"}
        </button>
      </div>

      {error && <p className="hora-error">❌ {error}</p>}

      {result && (
        <div className="hora-result">
          <h3 className="hora-day">📅 Day: {result.day_of_week}</h3>
          <div className="hora-grid">
            {result.horas.map((item, idx) => (
              <div className="hora-card" key={idx}>
                <h4>{item.hora}</h4>
                <p><strong>🕒 Start:</strong> {item.start}</p>
                <p><strong>🕓 End:</strong> {item.end}</p>
                <p><strong>✨ Benefits:</strong> {item.benefits}</p>
                <p><strong>💎 Lucky Gem:</strong> {item.lucky_gem}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default HoraMuhurta;
